import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FC } from 'react';

export interface ExcelOption {
  value: number;
  label: string;
}
interface ExportExcelProps {
  onExcelChanged: (e: DropDownListChangeEvent) => void;
  width: number | string;
  excelOption: ExcelOption;
  disabled?: boolean;
}

const excelOptions: ExcelOption[] = [
  { value: 0, label: 'Export to Excel...' },
  { value: 1, label: 'Current Page' },
  { value: 2, label: 'All Pages' },
];

export const defaultExcelOption: ExcelOption = { value: 0, label: 'Export to Excel...' };

const ExportExcel: FC<ExportExcelProps> = ({ onExcelChanged, width, excelOption, disabled }) => (
  <DropDownList
    id="view-drop-down-list"
    style={{ width }}
    data={excelOptions}
    value={excelOption}
    textField="label"
    dataItemKey="value"
    onChange={onExcelChanged}
    disabled={disabled}
  />
);

export default ExportExcel;
